// extracted by mini-css-extract-plugin
module.exports = {"main":"App_main__3ZkGI","centered":"App_centered__2lsYq"};